const EXACT_SERVICE_NAME_MAP = {
  'brow lamination': 'Brow Lamination',
  buco: 'Buço',
  'depilacao buco': 'Depilação de Buço',
  'depilacao de buco': 'Depilação de Buço',
  cilios: 'Cílios',
  'extensao de cilios': 'Extensão de Cílios',
  'cilios manutencao': 'Manutenção de Cílios',
  'cilios manutencao 15 dias': 'Cílios Manutenção 15 Dias',
  'cilios manutencao 21 dias': 'Cílios Manutenção 21 Dias',
  'manutencao de cilios': 'Manutenção de Cílios',
  'manutencao de cilios (15 dias)': 'Manutenção de Cílios (15 dias)',
  'manutencao de cilios 15 dias': 'Manutenção de Cílios (15 dias)',
  'manutencao de cilios (21 dias)': 'Manutenção de Cílios (21 dias)',
  'manutencao de cilios 21 dias': 'Manutenção de Cílios (21 dias)',
  'manutencao cilios': 'Manutenção de Cílios',
  'manutencao 15 dias': 'Manutenção de Cílios (15 dias)',
  'manutencao 21 dias': 'Manutenção de Cílios (21 dias)',
  'manutencao': 'Manutenção de Cílios',
  lashlifting: 'Lashlifting',
  'limpeza de pele': 'Limpeza de Pele',
  maquiagem: 'Maquiagem',
  micropigmentacao: 'Micropigmentação',
  'sobrancelha simples': 'Sobrancelha Simples',
  'sobrancelha tintura': 'Sobrancelha Tintura',
};

const normalizeKey = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export function formatServiceName(value = '') {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const normalized = normalizeKey(value);
  return EXACT_SERVICE_NAME_MAP[normalized] || String(value);
}

export function formatServiceNameList(value = '') {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  return String(value)
    .split(/\s*[|,]\s*/)
    .map((item) => formatServiceName(item.trim()))
    .filter(Boolean)
    .join(' | ');
}